// The recommended way to test whether a hotkey shoudl be ⌘ or ctrl. Per:
//
//   * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/platform#examples
//   * https://github.com/ccampbell/mousetrap/blob/2f9a476ba6158ba69763e4fcf914966cc72ef433/mousetrap.js#L135
export const platformUsesCommandKey = () =>
	typeof navigator != "undefined" ? /Mac|iPod|iPhone|iPad/.test(navigator.platform) : false;
